import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

/**
 * Microsoft 4-color square logo icon
 * Used for Microsoft Entra ID / Azure AD authentication button
 */
export const MicrosoftIcon = createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 21 21">
    <rect x="1" y="1" width="9" height="9" fill="#F25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
    <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
    <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
  </svg>,
  'MicrosoftIcon'
);
